export const SET_NETWORK_ERROR = 'SET_NETWORK_ERROR';
export const CLEAR_NETWORK_ERROR = 'CLEAR_NETWORK_ERROR';

export const setNetworkError = error => ({
  type: SET_NETWORK_ERROR,
  payload: error,
});

export const clearNetworkError = () => ({
  type: CLEAR_NETWORK_ERROR,
});
